<template>
  <div id="tab2">
    <validation-observer ref="observer">
      <div class="row mt-n4">
        <div class="col-12">
          <SectionTitle
            icon="fas fa-address-card"
            content="Información de Garantías Procesales"
            container-class="tag-badge-main-info mb-4"
          />
          <SectionTitle
            content="Garantías Procesales"
            :has-line="true"
            class="custom-section-title pr-n5"
          />
        </div>
      </div>
      <div
        v-for="(row, indx) in rowList"
        :key="row.id"
        class="question-element"
      >
        <div class="item-pane">
          <div class="question-box">
            <div class="box-number">
              <div>
                {{ indx + 1 }}
                <sup class="question-number-sup" />
              </div>
            </div>
          </div>
          <div class="flex-grow-1 info-section">
            <div class="question-line ml-4 flex-grow-1 py-3">
              <div class="row">
                <div class="col-md-12 col-sm-12">
                  <div
                    v-if="
                      row.id == idQuestionForDocument &&
                        row.radioButton.options.find(
                          (elem) => elem.label == 'Si'
                        ).check == true
                    "
                  >
                    <label>{{ row.name }}</label>
                    <hr />
                    <div class="row ml-0">
                      <label>Fecha de Certificación</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3 col-sm-12 mt-2">
                        <label>Fecha:</label>
                        <ValidationProvider
                          v-slot="{ errors }"
                          name="fecha"
                          :rules="!isReadMode ? 'required' : ''"
                        >
                          <DatePicker
                            :max-date="new Date()"
                            required="required"
                            :error="errors[0]"
                            :value="certificateDate"
                            :custom-error-msg="errors[0]"
                            :disabled="isReadMode || !canEditTab2"
                            @onSelectedDate="onDateChanged"
                          />
                        </ValidationProvider>
                      </div>
                      <div class="mt-2">
                        <div>
                          <div class="col-md-12 col-sm-12">
                            <label>Documento:</label>
                            <ValidationProvider
                              v-slot="{ errors }"
                              :rules="{ required_if: documentId }"
                            >
                              <CustomFileInput
                                ref="fileUpload2"
                                v-model="docValue"
                                :can-replace="canReplace"
                                :max-size="10"
                                :attachment-id="documentId"
                                :accept="allowedFiles"
                                :error="errors[0] ? errorMsg : ''"
                                :name="Name"
                                :custom-error-msg="errors[0] ? errorMsg : ''"
                                :disabled="isReadMode || !canEditTab2"
                                @input="documentChanged"
                                @replace="documentReplace"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-else class="mb-0 p-2">
                    {{ row.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row action-section">
            <div class="align-items-end d-flex p-0 custom-radio-container">
              <ValidationProvider>
                <RadioButton :question-lists="row.radioButton" />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <FixedBottomSaveButton v-if="isPreRegistred" :offset="200" @click="save" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations } = createNamespacedHelpers('$_student');
import store from '@/store/index';
import { SectionTitle } from '@/components/pei/shared/';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import RadioButton from '@/components/common/CustomRadioButton';
import DatePicker from '@/components/common/CustomDatePicker';
import mixAlert from '@/mixin/alert.mixin';
import RegistryTabNumber from '@/utils/constants/student/registryTabNumber';
import AnswerResponse from '@/utils/constants/reg/answerResponse';
import ProceduralGuaranteeCodes from '@/utils/constants/reg/RegProceduralGuaranteeCodes';
import validGuid from '@/utils/constants/InvalidGuid';
import CustomFileInput from '@/components/common/CustomFileInput';
import objectToFormData from 'object-to-formdata';
import moment from 'moment';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';

export default {
  name: 'Tab2',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    ValidationProvider,
    ValidationObserver,
    RadioButton,
    DatePicker,
    CustomFileInput,
    FixedBottomSaveButton,
  },
  data() {
    return {
      rowList: [],
      docValue: null,
      allowedFiles: '.pdf',
      Name: null,
      errorMsg: 'Favor de anejar el documento.',
      idQuestionForDocument:
        ProceduralGuaranteeCodes.ReciboDiscusiónDocumentoDerechosPadres,
      certificateDate: null,
      documentId: null,
      canEditTab2: store.getters.HasPermission('registry.editTab2'),
    };
  },
  computed: {
    ...mapState([
      'studentPreRegistryValidations',
      'selectedStudentPreRegistry',
    ]),
    isInvalid() {
      return (
        this.studentPreRegistryValidations.filter(
          (x) => x === RegistryTabNumber.ProceduralGuarantees
        ).length > 0
      );
    },
    isReadMode() {
      return this.selectedStudentPreRegistry.isReadMode;
    },
    hasDocument() {
      return this.documentId !== null && this.documentId.length !== 0;
    },
    studentStatus() {
      return this.$store.getters.SelectedStudent.status;
    },
    isPreRegistred() {
      return this.studentStatus === 'Pre-Registro';
    },
    canReplace() {
      return store.getters.HasPermission('registry.canReplaceProceduralGuarantee');
    },
  },
  async activated() {
    // this methods are for sending the save method and the discardChanges
    // when this tab is activated (being the tab displayed)
    this.$store.commit('setSaveMethod', this.save);
    this.$store.commit('setResetOriginalDataMethod', this.discardChanges);
  },
  methods: {
    ...mapMutations(['setStudentPreRegistryValidations']),
    async raiseValidate() {
      await this.$refs.proceduralGuaranteesForm.validate();
    },
    checkInvalidRadio(rows) {
      rows.map((val) => {
        val.radioButton.invalid = !val.radioButton.options.some(
          (elem) => elem.check == true
        );
      });
    },
    documentChanged(documentElement) {
      if (documentElement === null) this.documentId = null;
    },
    async documentReplace(documentElement) {
      if (documentElement === null) this.documentId = null;

      let data = {
        RegStudentId: store.state.$_student.selectedStudent.regStudentId,
        Document: documentElement,
      };

      let requestparam = objectToFormData(data, { indices: true });
      try {
        await this.$ApiPost('api/student/replaceproceduralguarantee', requestparam);
      
        this.ShowToast(
          'Informacion',
          'Documento actualizado exitosamente',
          'success'
        );

        await this.loadQuestionary();
      } catch {
        this.ShowToast("", "Error al intentar actualizar el documento", "error");;
      }
    },
    async save() {
      let self = this;
      let incompleteForm = false;
      let noAnswer = false;
      let regStudent =
        store.state.$_student.selectedStudentPreRegistry.regStudentId;

      let data = {
        StudentSieId: store.state.$_student.selectedStudent.studentId,
        RegStudentId: regStudent,
        GuaranteeAnswer: [],
        Document: {},
        CertificateDate: moment(this.certificateDate).format('YYYY-MM-DD'),
      };

      await self.rowList.map((val) => {
        val.radioButton.invalid = !val.radioButton.options.some(
          (elem) => elem.check == true
        );
        let noResult = val.radioButton.options.some(
          (elem) => elem.check == true && elem.label == 'No'
        );

        let item = val.radioButton.options.find((elem) => elem.check == true);
        if (item) {
          let answer = {
            RegProceduralGuaranteeAnswerCode: item.label,
            RegProceduralGuaranteeCode: val.id,
          };

          data.GuaranteeAnswer.push(answer);
        }

        if (val.radioButton.invalid == true) {
          incompleteForm = true;
        }

        if (noResult == true) {
          noAnswer = noResult;
        }
      });

      if (incompleteForm) {
        self.ShowToast(
          'Error',
          'Favor seleccionar al menos una de las opciones para continuar.',
          'error'
        );
        return;
      }

      if (noAnswer) {
        self
          .$ApiGet('api/validationsmessages', { messageCodes: 17009 })
          .then((response) => {
            let itemMsj = response.data[0];
            self.ShowToast('Error', itemMsj.name, 'error');
          });
        return;
      }

      if (self.docValue == null && !self.hasDocument) {
        self.$refs.observer.validate();
        return;
      }

      data.Document = self.docValue;
      let requestparam = objectToFormData(data, { indices: true });
      self
        .$ApiPost('api/student/saveproceduralguarantee', requestparam)
        .then(() => {
          self.ShowToast(
            'Informacion',
            'Registro actualizado exitosamente',
            'success'
          );
          self.clearInvalidFeedback();
        });
    },
    discardChanges() {
      // here goes the discard changes method for setting the data to the default values or value stored in db
      // this method is for being called when the user doesn't want the new changes to be applied when
      // leaving this tab.
    },
    loadQuestionary() {
      let self = this;
      let regStudent = store.state.$_student.selectedStudent.regStudentId;
      regStudent =
        regStudent == 'No Disponible'
          ? store.state.$_student.selectedStudentPreRegistry.regStudentId
          : regStudent;
      self
        .$ApiGet(`api/student/proceduralquestionary/${regStudent}`)
        .then((response) => {
          let item = response.data;
          item.map((val) => {
            let Question = {
              id: val.peiCode,
              name: val.description,
              radioButton: {
                name: val.description,
                isRequired: true,
                invalid: null,
              },
            };

            if (
              val.peiCode ==
                ProceduralGuaranteeCodes.ReciboDiscusiónDocumentoDerechosPadres &&
              val.documentId != validGuid.Invalid
            ) {
              self.documentId = val.documentId;
              this.certificateDate = new Date(val.certificateDate);
            }

            Question.radioButton.options = val.na
              ? [
                  {
                    label: 'Si',
                    check:
                      val.regProceduralGuaranteeAnswerCode == AnswerResponse.Si,
                    disabled: this.isReadMode || !this.canEditTab2,
                  },
                  {
                    label: 'No',
                    check:
                      val.regProceduralGuaranteeAnswerCode == AnswerResponse.No,
                    disabled: this.isReadMode || !this.canEditTab2,
                  },
                  {
                    label: 'N/A',
                    check:
                      val.regProceduralGuaranteeAnswerCode == AnswerResponse.NA,
                    disabled: this.isReadMode || !this.canEditTab2,
                  },
                ]
              : [
                  {
                    label: 'Si',
                    check:
                      val.regProceduralGuaranteeAnswerCode == AnswerResponse.Si,
                    disabled: this.isReadMode || !this.canEditTab2,
                  },
                  {
                    label: 'No',
                    check:
                      val.regProceduralGuaranteeAnswerCode == AnswerResponse.NA,
                    disabled: this.isReadMode || !this.canEditTab2,
                  },
                ];
            self.rowList.push(Question);

            // If register event has been call, so invoke validation method
            if (this.isInvalid) {
              this.checkInvalidRadio(self.rowList);
            }
          });
        });
    },
    clearInvalidFeedback() {
      const _numbers = this.studentPreRegistryValidations.filter(
        (x) => x !== RegistryTabNumber.ProceduralGuarantees
      );
      this.setStudentPreRegistryValidations(_numbers);
      this.setInvalidTabs(_numbers);
    },
    setInvalidTabs(tabNumbers) {
      this.$emit('set-invalid-tabs', tabNumbers, true);
    },
    onDateChanged(date) {
      this.certificateDate = new Date(date);
    },
  },
  mounted() {
    this.loadQuestionary();
  },
};
</script>

<style scoped>
.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-box {
  width: 65px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-number {
  font: Bold 32px/19px Lato;
}
.question-line.pl-55 {
  padding-left: 55px !important;
}
.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

.row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.text-fix {
  font-weight: 400;
}
.relative-top-10 {
  position: relative;
  top: 0.8em;
}

@media screen and (max-width: 768px) {
  .item-pane {
    flex: 1 1 auto !important;
  }
  .question-box {
    padding: 10px !important;
    width: unset !important;
  }
  .info-section {
    flex-grow: 1 !important;
    flex-shrink: 1 !important;
    flex-basis: auto !important;
  }
  .action-section {
    flex: 1 1 auto !important;
  }
}
</style>
